/* jshint esversion: 8 */
define([
    "lit-element/lit-element.bundled",
    "components/cloudCenterElement",
    "validation/inlineComponentValidation",
    "components/inlinePopover",
    "util"
], function(
    Lit,
    CloudCenterElement,
    InlineComponentValidation,
    InlinePopover,
    Util
) {

    class ImagePicker extends CloudCenterElement {

        constructor () {
            super();
        }

        cceInitialize () {
            super.cceInitialize();
            Util.consoleLogTrace('ManagementCloudAccount`, `cceInitialize invoked');
            // Default values
            this.elementlabel = "";
            this.poptext = "";
            this.dduxenabled = false;
            this.imagePickerInputid = "";
            this.imagePickerInputplaceholder = "";
            this.imagePickerInputvalue = "";
        }

        firstUpdated() {
            Util.consoleLogTrace(`ImagePicker.firstUpdated`, `invoked`);

            // element could be hidden
            if (this.imagePickerInputid !== "") {
                const selectInput = this.renderRoot.querySelector(`select#${this.imagePickerInputid}`);
                selectInput[0].text = this.getProductName().toUpperCase() + " " + this.getSavedStep1Values().visible.releaseSelector + " (default)"
            } else {
                const container = this.renderRoot.querySelector(`fieldset.section2Group`);
                container.hidden = true;
            }
        }

        // Reactive Properties -- updates rendering when values change
        static get properties () {
            return {
                elementlabel: {type: String},
                poptext: {type: String},
                dduxenabled: {type: Boolean},
                imagePickerInputid: {type: String},
                imagePickerInputplaceholder: {type: String},
                imagePickerInputvalue: {type: String}
            };
        }

        // Render element template
        render () {
            return Lit.html`
            <fieldset class ="section2Group custom-element-input">
                <div class = "section2InputContainer">
                    <label for="${'imagePickerFieldset' + this.timestamp}">${this.elementlabel}</label>
                    <div class="section2InputValidationContainer custom-element-input" id="${'imagePickerFieldset' + this.timestamp}">
                        <select id="${this.imagePickerInputid}" name="${this.imagePickerInputid}" placeholder="${this.imagePickerInputplaceholder}" value="${this.imagePickerInputvalue}">
                            <option value="">MATLAB R2025b (default)</option>
                        </select>
                        <inline-validation elementid="${this.imagePickerInputid}" />
                    </div>
                    <inline-popover class="custom-element-input" poptext="${this.poptext}" />
                </div>
            </fieldset>
            `;
        }
    }

    customElements.define('image-picker', ImagePicker);

    return ImagePicker;
});
